import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Dropdown, Label, Grid, Checkbox } from "semantic-ui-react";
import { truncate, isEmpty, map, includes, toLower, isEqual, get, isNumber, filter } from "lodash";
import Joi from "joi";
import PropTypes from "prop-types";

// Components
import Input from "@Components/Input";
import Text from "@Components/Text";
import IKModal from "@Components/IkModal";
import FileManager from "@Components/FileManager";

// Modals
import ImageView from "@Modals/ImageView";
import ConfirmModal from "@Modals/ConfirmModal";

// redux
import genericAction from "@Actions/generic";
import { connect } from "react-redux";

// utils
import { dropdownFormat } from "@Utils/formats";
import { compressImage } from "@Utils/functionality";
// import { AsYouType } from "libphonenumber-js";
import archiveOption from "../../staticData";

// Styles
import styles from "./styles.module.css";
import TextAreaInput from "@Components/TextArea";

const PresetMessageCrud = ({ modalCrud, tableValue, dispatch, userName, typesList, onClose, apiData, presetMessages }) => {
	const schema = Joi.object().keys({
		fileVerificacion: Joi.string().messages({
			"string.empty": `Archivo es un campo requerido`,
		}),
		title: Joi.string().messages({
			"string.empty": "Título es un campo requerido",
		}),
		repeatTitle: Joi.string().messages({
			"string.empty": "El Título ya existe",
		}),
		messageArea: Joi.string().messages({
			"string.empty": "Mensaje es un campo requerido",
		}),
		types: Joi.number().min(0).messages({
			"number.base": "Tipo es un campo requerido",
		}),
		flowId: Joi.number().messages({
			"number.base": "Flow es un campo requerido",
		}),
	});
	const fileInputRef = useRef(null);
	const [typesData, setTypesData] = useState([]);
	const [open, setOpen] = useState(false);
	const [openImage, setOpenImage] = useState(false);
	const [fileImage, setFileImage] = useState("");
	const [initialFormData, setInitialFormData] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [images, setImages] = useState([]);
	const [flowOptions, setFlowOptions] = useState([]);

	const [formData, setFormData] = useState({
		fileData: {},
		types: "",
		sendProfile: false,
		messageArea: "",
		admin: "",
		title: "",
		fileText: "",
		typeRadio: "Text",
		formatFile: ".txt",
		uri: "",
		isActive: true,
		flowId: "",
	});
	const [errors, setErrors] = useState({
		fileVerificacion: "",
		repeatTitle: "",
		types: "",
		title: "",
		messageArea: "",
		flowId: "",
	});

	useEffect(() => {
		(async () => {
			// const presetMessagesPromise = dataHandler({
			// 	dispatch,
			// 	url: `presetMessages/${tableValue.id}`,
			// 	// params: defaultParams,
			// });

			// const [presetMessagesResponse] = await Promise.all([presetMessagesPromise]);
			setModalOption(modalCrud);
			setTypesData(dropdownFormat(typesList, "name", "id"));

			try {
				const flowsResponse = await dispatch(genericAction({ method: "get", route: "flows/table" }));
				if (flowsResponse && flowsResponse.items) {
					setFlowOptions(
						map(
							filter(flowsResponse.items, (f) => {
								return f.isActive;
							}),
							(f) => {
								return { key: f.id, text: f.name, value: f.id };
							}
						)
					);
				} else if (Array.isArray(flowsResponse)) {
					setFlowOptions(
						map(
							filter(flowsResponse, (f) => {
								return f.isActive;
							}),
							(f) => {
								return { key: f.id, text: f.name, value: f.id };
							}
						)
					);
				}
			} catch (err) {
				// eslint-disable-next-line no-console
				console.error("Error fetching flows:", err);
			}

			if (!isEmpty(tableValue)) {
				const logo = get(tableValue, "uri", []);
				setImages(logo ? [logo] : []);
				setFormData({
					...formData,
					fileText: get(tableValue, "uri", ""),
					fileData: get(tableValue, "uri", {}),
					types: get(tableValue, "type.id", ""),
					sendProfile: get(tableValue, "settings.sendProfile", false),
					isActive: get(tableValue, "isActive", true),
					messageArea: get(tableValue, "text", ""),
					admin: userName,
					title: get(tableValue, "title", ""),
					typeRadio: get(tableValue, "msgType", "Text"),
					flowId: get(tableValue, "flowId", ""),
				});
				setFileImage(get(tableValue, "uri", {}));
				setInitialFormData({
					...formData,
					fileText: get(tableValue, "uri", ""),
					fileData: get(tableValue, "uri", {}),
					types: get(tableValue, "type.id", ""),
					isActive: get(tableValue, "isActive", true),
					messageArea: get(tableValue, "text", ""),
					admin: userName,

					title: get(tableValue, "title", ""),
					typeRadio: get(tableValue, "msgType", "Text"),
					flowId: get(tableValue, "flowId", ""),
				});
			} else {
				setFormData({
					...formData,
					admin: userName,
				});
				setInitialFormData({
					...formData,
					admin: userName,
				});
			}
		})();
	}, [tableValue]);

	// save handlers
	const savedData = async () => {
		let repeatTitle = "ejemplo";

		if (isEmpty(tableValue) && !isEmpty(formData.title)) {
			map(presetMessages, (item) => {
				if (includes(toLower(item.title), toLower(formData.title))) {
					repeatTitle = "";
				}
			});
		}

		const fileVerificacion = formData.typeRadio !== "Text" && formData.typeRadio !== "Flow" && isEmpty(images) ? "" : "ok";

		let validation = {};
		if (formData.typeRadio === "Text") {
			validation = schema.validate(
				{
					fileVerificacion,
					messageArea: formData.messageArea,
					title: formData.title,
					repeatTitle,
					types: formData.types,
				},
				{ abortEarly: false }
			);
		} else if (formData.typeRadio === "Flow") {
			validation = schema.validate(
				{
					fileVerificacion,
					title: formData.title,
					repeatTitle,
					types: formData.types,
					flowId: formData.flowId,
				},
				{ abortEarly: false }
			);
		} else {
			validation = schema.validate(
				{
					fileVerificacion,
					title: formData.title,
					repeatTitle,
					types: formData.types,
				},
				{ abortEarly: false }
			);
		}

		if (validation.error) {
			const { details } = validation.error;
			let errorsVal = {
				title: "",
				messageArea: "",
				fileVerificacion: "",
				types: "",
				flowId: "",
			};

			map(details, (item) => {
				errorsVal = { ...errorsVal, [item.context.key]: item.message };
			});
			setErrors(errorsVal);
		} else {
			const typesValue = isNumber(formData.types) ? formData.types : null;

			if (modalOption === "Edit") {
				const dataToEditor = {};

				if (formData.title !== tableValue.title) dataToEditor.title = formData.title;
				if (formData.isActive !== get(tableValue, "isActive", true)) dataToEditor.isActive = formData.isActive;
				if (formData.typeRadio !== tableValue.msgType) dataToEditor.msgType = formData.typeRadio;
				if (formData.typeRadio !== "Flow" && formData.messageArea !== tableValue.text) dataToEditor.text = formData.messageArea;
				if (formData.typeRadio === "Flow" && Number(formData.flowId) !== tableValue.flowId) dataToEditor.flowId = Number(formData.flowId);
				if (formData.sendProfile !== get(tableValue, "settings.sendProfile", false)) {
					dataToEditor.settings = { sendProfile: formData.sendProfile };
				}
				if (!isEmpty(images) && !isEqual(images, [get(tableValue, "uri")])) {
					dataToEditor.uri = images;
				}
				if (typesValue !== tableValue.typeId) dataToEditor.typeId = typesValue;

				if (!isEmpty(dataToEditor)) {
					const dataEdit = await dispatch(
						genericAction({
							method: "patch",
							route: `presetMessages/${tableValue.id}`,
							body: dataToEditor,
						})
					);

					if (!isEmpty(dataEdit)) {
						apiData("Edit");
						setInitialFormData(formData);
						setErrors({
							fileVerificacion: "",
							repeatTitle: "",
							types: "",
							title: "",
							messageArea: "",
							flowId: "",
						});
					}
				}
			} else {
				const data = {
					settings: { sendProfile: formData.sendProfile },
					title: formData.title,
					isActive: formData.isActive,
					msgType: formData.typeRadio,
					...(formData.typeRadio !== "Flow" ? { text: formData.messageArea } : {}),
					...(formData.typeRadio === "Flow" && formData.flowId ? { flowId: Number(formData.flowId) } : {}),
					typeId: typesValue,
					...(formData.typeRadio !== "Text" && !isEmpty(images) ? { uri: images } : {}),
				};

				const dataAdd = await dispatch(
					genericAction({
						method: "post",
						route: `presetMessages`,
						body: data,
					})
				);

				if (!isEmpty(dataAdd)) {
					const newFormData = {
						fileData: {},
						types: "",
						sendProfile: false,
						messageArea: "",
						fileVerificacion: "",
						repeatTitle: "",
						admin: userName,
						title: "",
						fileText: "",
						typeRadio: "Text",
						formatFile: ".txt",
						isActive: true,
						flowId: "",
					};
					setFormData(newFormData);
					setInitialFormData(newFormData);
					setImages([]);
					apiData("Add");
					setErrors({
						fileVerificacion: "",
						repeatTitle: "",
						types: "",
						title: "",
						messageArea: "",
						flowId: "",
					});
				}
			}
		}
	};

	// archive handlers
	const archiveOptionHandler = (event, { name, value }) => {
		if (value === "Document") {
			setFormData({
				...formData,
				[name]: value,
				messageArea: "",
				fileData: {},
			});
		} else {
			if (value === "Image") {
				setFormData({
					...formData,
					[name]: value,

					fileData: {},
				});
				setErrors({ ...errors, fileVerificacion: "", messageArea: errors.messageArea });
			} else if (value === "Text" || value === "Flow") {
				setFormData({
					...formData,
					fileData: {},
					[name]: value,
				});
			}
			setErrors({ ...errors, fileVerificacion: "", messageArea: errors.messageArea });
		}
	};

	const convertStringArchive = (string) => {
		switch (string) {
			case "Image":
				return "image/*";

			case "Document":
				return "*/*";

			case "Text":
				return ".txt";

			default:
				return "";
		}
	};

	const concatStringArchive = (string) => {
		if (!isEmpty(string)) {
			return truncate(string, {
				length: 30,
				omission: "...",
			});
		}
		return "";
	};

	const fileChange = async (e) => {
		if (e.target.files[0] !== undefined) {
			/// filtro
			let filterName = "";
			let filterBool = false;
			switch (formData.typeRadio) {
				case "Document":
					if (e.target.files[0].type === "application/pdf") {
						filterBool = true;
					} else {
						filterName = "Document invalido solo se aceptan documentos (.pdf)";
					}
					break;
				case "Image":
					if (
						truncate(e.target.files[0].type, {
							length: 5,
							omission: "",
						}) === "image"
					) {
						filterBool = true;
					} else {
						filterName = "Document invalido solo se aceptan Image";
					}
					break;
				case "Text":
					if (e.target.files[0].type === "text/plain") {
						filterBool = true;
					} else {
						filterName = "Document invalido solo se aceptan documentos (.txt)";
					}

					break;
				default:
					break;
			}

			if (!filterBool) {
				setFormData({
					...formData,
				});
				setErrors({ ...errors, messageArea: "", fileVerificacion: filterName });
			} else {
				const fileTextTrunca = truncate(e.target.files[0].name, {
					length: 20,
					omission: "...",
				});
				const fileArchive = e.target.files[0];
				const imageRegex = /image.*/g;
				let fileVal = null;
				const isImage = imageRegex.test(fileArchive.type);
				if (isImage) {
					fileVal = await compressImage(fileArchive);
				} else {
					fileVal = fileArchive;
				}
				if (fileVal.size < 10 * 1024 * 1024) {
					setFormData({
						...formData,
						fileText: fileTextTrunca,
						fileData: fileVal,
					});

					setErrors({ ...errors, fileVerificacion: "" });
					const reader = new FileReader();
					setFileImage(URL.createObjectURL(e.target.files[0]));
					reader.readAsDataURL(fileArchive);
				} else {
					setFormData({
						...formData,
						fileText: "El Tamaño Máximo de Subida de Document es de 10MB",
					});
					setErrors({ ...errors, messageArea: "", fileVerificacion: filterName });
				}
			}
		}
	};
	const convertStringTitle = (string) => {
		switch (string) {
			case "Image":
				return "Imagen";

			case "Document":
				return "Archivo";

			case "Text":
				return "Desactivado";

			default:
				return "";
		}
	};
	// input handlers
	const handleInputDropdown = (event, { name, value }) => {
		setFormData({
			...formData,
			[name]: value,
		});
		setErrors({ ...errors, types: "" });
	};
	// const handleCheckBox = (e, { name, checked }) => {
	// 	setFormData({
	// 		...formData,
	// 		[name]: checked,
	// 	});
	// 	setErrors({ ...errors, [name]: "" });
	// };

	const handleInputTextArea = (e) => {
		const { value } = e.target;
		let number = value;
		if (value.length > 4095) {
			number = truncate(value, {
				length: 4096,
				omission: "",
			});
		}

		setFormData({
			...formData,
			messageArea: number,
		});
		setErrors({ ...errors, messageArea: "" });
	};
	const handleInput = (e) => {
		const { name, value } = e.target;

		setFormData({
			...formData,
			[name]: value,
		});
		setErrors({ ...errors, [name]: "" });
	};
	// modal handlers
	const modalOpen = () => {
		if (isEqual(initialFormData, formData)) {
			cancelModal();
		} else if (open) {
			setOpen(false);
		} else {
			setOpen(true);
		}
	};

	const cancelModal = () => {
		onClose();
	};

	return (
		<>
			<IKModal
				title={modalOption === "Add" ? "Agregar Mensaje Predeterminado" : `Mensaje Predeterminado: ${get(tableValue, "title", "")} `}
				id={tableValue.id}
				mode={modalOption}
				setMode={setModalOption}
				onClose={modalOpen}
				onSuccess={savedData}
				fullHeight
				size="small">
				<Grid className={styles.grid}>
					<Grid.Row className={styles.grid}>
						<Grid.Column width={16} className={styles.grid}>
							<div className={styles.container}>
								<Form>
									<div className={styles.activeContainer}>
										<span className={styles.activeLabel}>Activo:</span>
										<Checkbox
											toggle
											disabled={modalOption === "Watch"}
											label={formData.isActive ? "Si" : "No"}
											name="isActive"
											checked={formData.isActive}
											onChange={(e, { name, checked }) => {
												setFormData({ ...formData, [name]: checked });
											}}
										/>
									</div>
								</Form>
								<div className={styles.containerGroup}>
									<div className={styles.containerGroupR}>
										<Form>
											<Input
												icon="barcode"
												disabled={modalOption === "Watch"}
												label="Título:"
												required
												placeholder="Título"
												name="title"
												fluid
												error={!isEmpty(errors.title) && { content: errors.title, pointing: "above" }}
												className={styles.inputChannel}
												value={formData.title}
												onChange={handleInput}
											/>
											<Label
												className={styles.messageError}
												style={isEmpty(errors.repeatTitle) ? { display: "none" } : null}
												pointing
												prompt>
												{errors.repeatTitle}
											</Label>
											<Text required className={isEmpty(errors.typeRadio) ? styles.textBox : styles.textBoxColor}>
												Formato: <span className={styles.required}>*</span>
											</Text>
											<Dropdown
												value={formData.typeRadio}
												name="typeRadio"
												disabled={modalOption === "Watch"}
												error={!isEmpty(errors.typeRadio)}
												onChange={archiveOptionHandler}
												placeholder="Elegir"
												fluid
												selection
												options={archiveOption}
											/>
											{formData.typeRadio === "Flow" && (
												<div style={{ marginTop: "15px" }}>
													<Text className={isEmpty(errors.flowId) ? styles.textBox : styles.textBoxColor}>
														Flow a enviar: <span className={styles.required}>*</span>
													</Text>
													<Dropdown
														value={formData.flowId}
														options={flowOptions}
														fluid
														disabled={modalOption === "Watch"}
														placeholder="Seleccione un Flow"
														name="flowId"
														onChange={(e, { value }) => {
															return setFormData({ ...formData, flowId: value });
														}}
														search
														selection
													/>
													<Label
														className={styles.messageErrorTextBox}
														style={isEmpty(errors.flowId) ? { display: "none" } : null}
														pointing
														prompt>
														{errors.flowId}
													</Label>
												</div>
											)}
										</Form>
										{formData.typeRadio === "Text" && (
											<>
												<Text disabled className={styles.textFont}>
													{formData.fileText}
												</Text>
												<Label
													className={styles.messageErrorTextBox}
													style={isEmpty(errors.fileVerificacion) ? { display: "none" } : null}
													pointing
													prompt>
													{errors.fileVerificacion}
												</Label>
											</>
										)}
										{formData.typeRadio === "Image" && (
											<>
												<Text className={styles.textUrl}>Imagen</Text>
												<FileManager images={images} setImages={setImages} disabled={modalOption === "Watch"} />
												<Label
													className={styles.messageErrorTextBox}
													style={isEmpty(errors.fileVerificacion) ? { display: "none" } : null}
													pointing
													prompt>
													{errors.fileVerificacion}
												</Label>
											</>
										)}

										{formData.typeRadio !== "Text" && formData.typeRadio !== "Image" && formData.typeRadio !== "Flow" && (
											<>
												<Text className={styles.textUrl}>{convertStringTitle(formData.typeRadio)}</Text>
												<div className={styles.buttonsDocument}>
													<div className={styles.row}>
														<button
															type="button"
															disabled={modalOption === "Watch"}
															onClick={() => {
																fileInputRef.current.click();
															}}>
															Seleccionar archivo
														</button>
														<Text disabled={modalOption === "Watch"} className={styles.textFont}>
															{concatStringArchive(formData.fileText)}
														</Text>
													</div>
													<Button
														icon="eye"
														disabled={isEmpty(formData.fileData)}
														primary
														size="mini"
														onClick={() => {
															setOpenImage(true);
														}}
														className={styles.sizebutton}
													/>
												</div>

												<input
													ref={fileInputRef}
													type="file"
													className={styles.inputImg}
													name="file"
													accept={convertStringArchive(formData.typeRadio)}
													onChange={fileChange}
													hidden
												/>
												<Label
													className={styles.messageErrorTextBox}
													style={isEmpty(errors.fileVerificacion) ? { display: "none" } : null}
													pointing
													prompt>
													{errors.fileVerificacion}
												</Label>
											</>
										)}
									</div>

									<div className={styles.containerGroupR}>
										<Form>
											<Form.Input
												label="Creado Por:"
												placeholder="Usuario"
												icon="user"
												name="admin"
												disabled={modalOption === "Watch"}
												fluid
												error={!isEmpty(errors.admin) && { content: errors.admin, pointing: "above" }}
												className={styles.inputChannel}
												value={formData.admin}
											/>

											<Text className={isEmpty(errors.types) ? styles.textBox : styles.textBoxColor}>
												Tipo: <span className={styles.required}>*</span>
											</Text>
											<Dropdown
												value={formData.types}
												options={typesData}
												fluid
												disabled={modalOption === "Watch"}
												placeholder="Tipo"
												name="types"
												className={styles.inputDropdown}
												clearable
												onChange={handleInputDropdown}
												search
												selection
											/>
											<Label
												className={styles.messageErrorTextBox}
												style={isEmpty(errors.types) ? { display: "none" } : null}
												pointing
												prompt>
												{errors.types}
											</Label>
										</Form>

										{/* {formData.types === 4 && (
											<div className={styles.checkboxContainer}>
												<div className={styles.label}>Enviar Registro</div>
												<Checkbox
													toggle
													disabled={modalOption === "Watch"}
													label={formData.sendProfile ? "Si" : "No"}
													name="sendProfile"
													checked={formData.sendProfile}
													onChange={handleCheckBox}
												/>
											</div>
										)} */}
									</div>
								</div>

								<Form className={styles.containerGroupFin}>
									<Label className={styles.messageErrorTextBox} style={isEmpty(errors.messageArea) ? { display: "none" } : null} prompt>
										{errors.messageArea}
									</Label>
									{formData.typeRadio !== "Flow" && (
										<TextAreaInput
											disabled={formData.typeRadio === "Document" || formData.typeRadio === "Image" || modalOption === "Watch"}
											label="Texto:"
											value={formData.messageArea}
											placeholder={`Escribir texto,\nComodín {{usuario}} {{contacto}} {{perfil}}`}
											name="messageArea"
											className={styles.textareaAutosize}
											onChange={handleInputTextArea}
											showCount
											maxLength={4096}
											minRows={1}
										/>
									)}
								</Form>
							</div>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</IKModal>

			{open && (
				<ConfirmModal
					visible
					centerModal
					header="Salir del formulario"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
				/>
			)}
			{openImage && (
				<ImageView
					visible
					fileImage={fileImage}
					onClose={() => {
						return setOpenImage(false);
					}}
				/>
			)}
		</>
	);
};
function mapStateToProps({ user }) {
	return {
		gruposData: [],
		dataCategory: [],
		userName: user.name,
	};
}
PresetMessageCrud.propTypes = {
	tableValue: PropTypes.object,
	dispatch: PropTypes.func,
	userName: PropTypes.string,
	typesList: PropTypes.array,
	onClose: PropTypes.func,
	apiData: PropTypes.func,
	modalCrud: PropTypes.string,
	presetMessages: PropTypes.array,
};
export default connect(mapStateToProps)(PresetMessageCrud);
